import {
  SET_EMAIL_AND_PASSWORD,
  SET_NEW_PASSWORD,
  SET_PASSWORD_CONFIRM,
  CREATE_PASSWORD_REQUEST,
  CREATE_PASSWORD_SUCCESS,
  CREATE_PASSWORD_FAILURE,
  VALIDATE_CREATE_PASSWORD,
  CREATE_PASSWORD_REDIRECT
} from 'constants/actionTypes';

export function setEmailAndToken(email, token) {
  return {
    type: SET_EMAIL_AND_PASSWORD,
    email,
    token
  };
}

export function setPassword(value) {
  return {
    type: SET_NEW_PASSWORD,
    value
  };
}

export function setPasswordConfirm(value) {
  return {
    type: SET_PASSWORD_CONFIRM,
    value
  };
}

export function createPassword() {
  return {
    type: CREATE_PASSWORD_REQUEST
  };
}

export function createPasswordSuccess() {
  return {
    type: CREATE_PASSWORD_SUCCESS
  };
}

export function createPasswordFailure(errorText = createPasswordFailure) {
  return {
    type: CREATE_PASSWORD_FAILURE,
    errorText
  };
}

export function validatePassword() {
  return {
    type: VALIDATE_CREATE_PASSWORD
  };
}

export function loginAndRedirect() {
  return {
    type: CREATE_PASSWORD_REDIRECT
  };
}
